'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('../');

var _ResolutionText = require('./ResolutionText.css');

var _ResolutionText2 = _interopRequireDefault(_ResolutionText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonResolutionText = (_dec = (0, _reactCssModules2.default)(_ResolutionText2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AmazonResolutionText, _Component);

  function AmazonResolutionText() {
    (0, _classCallCheck3.default)(this, AmazonResolutionText);
    return (0, _possibleConstructorReturn3.default)(this, (AmazonResolutionText.__proto__ || (0, _getPrototypeOf2.default)(AmazonResolutionText)).apply(this, arguments));
  }

  (0, _createClass3.default)(AmazonResolutionText, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            _.Link,
            {
              to: 'https://www.asyousow.org/resolutions/2021/12/10-amazon-report-on-aligning-retirement-plan-options-with-company-climate-goals',
              title: 'Amazon shareholder resolution',
              xstrong: true
            },
            'More resolution details',
            _react2.default.createElement(_.LinkIcon, null)
          )
        ),
        _react2.default.createElement(
          'blockquote',
          { styleName: 'company-resolution-blockquote' },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'WHEREAS:'
            ),
            ' Shareholders applaud Amazon for adopting ambitious operational climate goals:'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'p',
                null,
                'Amazon committed to achieve net-zero carbon emissions by 2040. Including to power operations with 100% renewable energy by 2025.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'p',
                null,
                'Shipment Zero: The company\u2019s vision is to make all Amazon shipments net zero carbon, delivering 50% of shipments with net zero carbon by 2030.\u201D Recent actions include ordering a fleet of 100,000 electric delivery vehicles.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'p',
                null,
                'Commitment to address UN Sustainable Development Goal 13 on Climate Action.'
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'While the Company has made significant efforts to address climate change across its operations, data from Securities and Exchange Commission (SEC) filings demonstrates misalignment between the Company\u2019s sustainability goals and investment options offered through the Amazon 401(k) Plan.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Every investment fund offered by the Amazon retirement plan, including the default option (holding 52% of employee investments), contains major oil and gas, fossil-fired utilities, coal, pipelines, oil field services, or companies in the agribusiness sector with deforestation risk. Image shows Amazon\'s 401(k) plan scoring poor for fossil fuels and deforestation on As You Sow\'s scorecard'
          ),
          _react2.default.createElement(
            'p',
            null,
            'A recent scorecard, produced by investor representative As You Sow, shows that the Amazon retirement plan default option is rated poor due to significant investments in fossil fuel companies and companies with deforestation risk.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Amazon\u2019s retirement plan currently offers no diversified equity funds that are low carbon, defined as intentionally avoiding investments in fossil fuels companies, companies with deforestation risk, and companies with high carbon emissions. It offers only one fund screened for environmental/social impact.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'As a result of these limited options, the vast majority of the $12.8 billion employee retirement dollars invested through the Amazon 401(k) Plan as of December 2020 was invested in funds rated poorly on carbon emissions.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Amazon\u2019s investment in high carbon companies through its retirement plan choices directly contradicts the climate reduction actions it has committed to take in its operations, creating cognitive dissonance and reputational risk. This may also make it more difficult to retain employees who are increasingly concerned about catastrophic climate impacts. Amazon Employees for Climate Justice staged a walk-out to publicly criticize the Company\u2019s contribution to climate change. The climate impact of continuing to choose high carbon retirement plan investments options over low carbon choices raises red flags for the Company\u2019s reputation.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'BE IT RESOLVED:'
            ),
            ' Shareholders request the Board, at reasonable expense and excluding proprietary information, prepare a report reviewing the Company\u2019s retirement plan options with the board\u2019s assessment of how the Company\u2019s current retirement plan options align with its climate action goals.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'SUPPORTING STATEMENT:'
            ),
            ' Proponent suggests the report include, at Board discretion:'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'p',
                null,
                'How Amazon could provide employees with more sustainable investment options such as a default option that is better aligned with global and Company climate goals;'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'p',
                null,
                'If the Board does not intend to include additional low carbon investment options in its employee retirement plan, a statement of the basis for its decision.'
              )
            )
          )
        )
      );
    }
  }]);
  return AmazonResolutionText;
}(_react.Component)) || _class);
exports.default = AmazonResolutionText;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ResolutionText/AmazonResolutionText.js
// module id = 1431
// module chunks = 0